import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./MobileMegaMenu.css";
import { useTranslation } from "react-i18next";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const MobileMegaMenu = ({categories}) => {
  const { t } = useTranslation();

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Filter to get main categories only
  const mainCategories = categories?.data?.filter(
    (category) => category.mainCategoryId === null && category.parentCategoryId === null
  ) || [];

  // Function to get subcategories based on mainCategoryId
  const getSubcategoriesByMainCategoryId = (mainCategoryId) => {
    if (!categories?.data) return [];
    
    // First, check if the main category has a subcategories array
    const mainCategory = categories.data.find(cat => cat._id === mainCategoryId);
    if (mainCategory && mainCategory.subcategories && mainCategory.subcategories.length > 0) {
      return mainCategory.subcategories;
    }
    
    // Try to find categories that have this specific mainCategoryId
    let filteredSubcategories = categories.data.filter(
      (category) => {
        // Handle case where mainCategoryId is an object with _id property
        const categoryMainId = category.mainCategoryId?._id || category.mainCategoryId;
        return String(categoryMainId) === String(mainCategoryId);
      }
    );
    
    // If no results, try with parentCategoryId
    if (filteredSubcategories.length === 0) {
      filteredSubcategories = categories.data.filter(
        (category) => {
          // Handle case where parentCategoryId is an object with _id property
          const categoryParentId = category.parentCategoryId?._id || category.parentCategoryId;
          return String(categoryParentId) === String(mainCategoryId);
        }
      );
    }
    
    // Return empty array if no subcategories found (don't show dummy data)
    return filteredSubcategories;
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <div className="mobile-menu-container">
      <button type="button" className="menu-item mobile-category-trigger" onClick={toggleMobileMenu} aria-expanded={mobileMenuOpen} aria-controls="mobile-category-menu">
        {t("Categories")}
      </button>

      <div id="mobile-category-menu" className={`mobile-menu ${mobileMenuOpen ? "open" : ""}`} aria-hidden={!mobileMenuOpen}>
        <div className="mobile-menu-header">
          <button type="button" className="close-button" onClick={toggleMobileMenu} aria-label="Stäng kategorimenyn">
            ✕
          </button>
        </div>
        <div className="categories-list" style={{ marginTop: "50px" }}>
          {mainCategories?.map((category) => (
            <Accordion key={category._id}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${category._id}-content`}
                id={`panel${category._id}-header`}
              >
                {/* Removed icon rendering for mobile simplicity */}
                <Typography sx={{marginY: "auto", fontWeight: "bold"}}>
                  {category.name}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Link to={`/products?category_id=${encodeURIComponent(category._id)}`} onClick={() => setMobileMenuOpen(false)} style={{ display: 'block', padding: '8px 12px', color: 'inherit', textUnderlineOffset: '3px' }}>
                  Visa alla i {category.name}
                </Link>
                {(() => {
                  const matchedSubcategories = getSubcategoriesByMainCategoryId(category._id);
                  return (
                    <>
                      {matchedSubcategories.length > 0 ? (
                        <div className="subcategory-list">
                          {matchedSubcategories.map((subcategory) => (
                            <Typography
                              component={Link}
                              to={`/products?category_id=${encodeURIComponent(subcategory._id)}`}
                              key={subcategory._id}
                              className="subcategory-item"
                              onClick={() => setMobileMenuOpen(false)}
                              style={{ 
                                cursor: "pointer", 
                                padding: "8px 12px",
                                margin: "4px 0",
                                backgroundColor: "rgba(255, 244, 189, 1)",
                                borderRadius: "6px",
                                border: "1px solid #e0e0e0",
                                display: "block",
                              }}
                            >
                              {subcategory.name}
                            </Typography>
                          ))}
                        </div>
                      ) : (
                        <Typography sx={{ 
                          fontSize: "12px", 
                          color: "#999", 
                          fontStyle: "italic",
                          textAlign: "center",
                          padding: "20px",
                          backgroundColor: "#f8f9fa",
                          borderRadius: "6px",
                          border: "1px dashed #ddd"
                        }}>
                          Inga underkategorier tillgängliga för {category.name}
                        </Typography>
                      )}
                    </>
                  );
                })()}
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MobileMegaMenu;
